import { Component, Input, ViewEncapsulation } from '@angular/core';
import { includes } from 'lodash';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { WrapUp } from 'common/api/models/wrap-up.model';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormFieldComponent {
  @Input()
  data: WrapUp;

  public fields;
  public builtInFieldNames;

  constructor() {
    // this.data will contain the field values:
    // id, label, name, options (id, label, value), required, type, value

    this.fields = bcEnums.wrapUpFields;
    this.builtInFieldNames = bcEnums.wrapUpBuiltInNames;
  }

  isBuiltInField(category) {
    return includes(this.builtInFieldNames, category);
  }

  dropdownValueChanged(selectedItem) {
    this.data.value = selectedItem.value;
  }

  onRadioBoxValueChange(value): void {
    this.data.value = value;
  }
}
